<div class="header-busqueda">
    <h1>Cumplimiento Empresas</h1>
    <div class="botones-tabs">
        <button
            type="button"
            class="btn-tab"
            [class.active]="activeTab === 'Productor/Importador'"
            *appPermiso="'realizar_seguimiento_de_cumplimiento_empresas_productor'"
            (click)="cambiarTab('Productor/Importador')">
            Productor/Importador
        </button>
        <button
            type="button"
            class="btn-tab"
            *appPermiso="'realizar_seguimiento_de_cumplimiento_empresas_comercializador'"
            [class.active]="activeTab === 'Comercializador'"
            (click)="cambiarTab('Comercializador')">
            Comercializador
        </button>
    </div>
</div>
<app-table
    *ngIf="activeTab == 'Productor/Importador'"
    [data]="data"
    [columns]="columns"
    [filters]="filters"
    [total]="total"
    [page]="pagina"
    [pageSize]="tamano"
    [textoRegistros]="'registros'"
    [textoMostrar]="'Mostrar'"
    [mostrarEnlaceRelacionar]="false"
    (filtersChange)="onFiltersChange($event)">
</app-table>
<app-table
    *ngIf="activeTab == 'Comercializador'"
    [data]=""
    [columns]="columns"
    [filters]="filters"
    [total]="'0'"
    [page]="'1'"
    [pageSize]="tamano"
    [textoRegistros]="'registros'"
    [textoMostrar]="'Mostrar'"
    [mostrarEnlaceRelacionar]="false"
    (filtersChange)="onFiltersChange($event)">
</app-table>
